import { useTranslation } from "react-i18next";
import { Dropdown } from "Components/Shared/Inputs/Dropdown";
import type { LoyaltyPeriodDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatMonthAndYear } from "Utils/DateUtils";

type Props = {
  periods: Array<LoyaltyPeriodDto>;
  value: number | undefined;
  onChange: (settlementPeriodId: number) => void;
};

export const LoyaltyMonthDropdown = ({ periods, value, onChange }: Props) => {
  const { t } = useResource();
  const { i18n } = useTranslation();

  const options = periods.map(({ settlementPeriodId, year, month }) => ({
    Value: settlementPeriodId,
    Name: formatMonthAndYear(year, month, i18n.language),
  }));

  return (
    <Dropdown
      name="loyalty-month"
      label={t(Resources.Common.Month)}
      value={value}
      onChange={onChange}
      options={options}
    />
  );
};
